import * as _ from 'lodash'

import mixins from 'vue-typed-mixins'
import { TranslateResult } from 'vue-i18n'
import { Redemption } from '~models/redemption'

import Utilities from '~mixins/utilities'
import { Voucher } from '~models/voucher'

export default mixins(Utilities).extend({
  data(): {
    showExitPopup: boolean;
    showAddVoucherPopup: boolean;
    voucherToDelete: Voucher | null;
  } {
    return {
      showExitPopup: false,
      showAddVoucherPopup: false,
      voucherToDelete: null,
    }
  },
  computed: {
    redemption(): Redemption {
      return this.$store.state.redemptions.redemption
    },
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
    errors(): string[] {
      return this.$store.state.redemptions.errors
    },
    firstErrorKey(): string {
      return this.errors[0]
    },
    remainingFlightVoucherBalance(): number {
      const remainingBalance = (this.redemption.vouchersBalance || 0) - this.redemption.amount

      return remainingBalance < 0 ? 0 : remainingBalance
    },
    currency(): string | undefined {
      return this.redemption.paymentSummary?.currency?.toUpperCase()
    },
    market(): string | undefined {
      return this.redemption.countryOfDeparture
    },
    paymentRequired(): boolean {
      return !!this.redemption?.paymentSummary?.fromCard
    },
    maxVouchers(): number {
      return this.redemption.maxVouchersCount || 1
    },
    shouldShowAddAnotherVoucher(): boolean {
      return this.redemption.appliedVouchers.length < this.maxVouchers && this.paymentRequired
    },
  },

  methods: {
    translateType(type: string): TranslateResult {
      const fallbackLocale = typeof (this.$i18n.fallbackLocale) === 'string' ? this.$i18n.fallbackLocale : 'en'

      if (
        this.$te(`components.summary.table.vouchers.voucher_types.${type}`)
        || this.$te(`components.summary.table.vouchers.voucher_types.${type}`, fallbackLocale)
      ) {
        return this.$t(`components.summary.table.vouchers.voucher_types.${type}`)
      }

      return this.$t('components.summary.table.vouchers.voucher_types.default')
    },
    async deleteVoucher(voucher: Voucher) {
      if (this.redemption.appliedVouchers.length <= 1) {
        this.showExitPopup = true
      } else {
        this.voucherToDelete = voucher
      }
    },
    async confirmRedemption() {
      await this.$store.dispatch('redemptions/checkout', { redemptionId: this.redemption.id, appliedVouchersBalance: this.redemption.vouchersBalance })

      if (_.isEmpty(this.errors)) {
        window.location.assign(this.redemption.confirmationUrl)
      } else {
        // 1. Reload the redemption because the vouchers balance might have changed
        // 2. Don't need to dispatch redemptions/initializeDatatrans
        // because user don't need to do payment in this page
        // 3. Disable resetError here so user can see the error displayed on the UI
        this.$store.dispatch('redemptions/getRedemption', { redemptionId: this.redemption.id, resetError: false })
      }
    },
    onRemoveVoucherInput(val: boolean) {
      if (!val) {
        this.voucherToDelete = null
      }
    },
    async continueToCCPayment() {
      await this.$store.dispatch('redemptions/validateVouchers', { redemptionId: this.redemption.id })

      if (_.isEmpty(this.errors)) {
        this.$router.push({ name: 'redemption-payment' })
      }
    },
  },
})
